import React from "react"
import "./footer.css"

const Footer = () => {
  return (
    <>
      <footer>
        <div className='container flexSB'>
          <div className='headingContainer'>
            <p>
              © Powered by SLTMobitel <span>Digital Projects.</span>
            </p>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer
